import { MatomoInstance } from "services/analytics";
import { createContext } from "../createContext";

export const [useMatomoContext, MatomoContextProvider] = createContext<MatomoInstance>();
